module.exports = __webpack_public_path__ + "img/closed_status.d527b8d3.svg";